<template>
  <div class="flex flex-row gap-12">
    <div class="flex flex-col items-center">
      <div
        class="bg-static-default-mid flex h-40 w-40 shrink-0 items-center justify-center rounded-full"
      >
        <slot name="icon">
          <span class="body-1-bold">{{ number }}</span>
        </slot>
      </div>
      <RevDivider v-if="!isLast" class="grow" variant="vertical" />
    </div>
    <div class="flex flex-1 flex-col gap-4 pt-8" :class="{ 'pb-24': !isLast }">
      <p class="body-1-bold">
        <slot name="title">{{ title }}</slot>
      </p>

      <p class="text-static-default-low body-2">
        <slot name="description">{{ description }}</slot>
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { RevDivider } from '@ds/components/Divider'

// RevStatusTracker (@ds/components/StatusTracker) requires a `currentStep` and
// models done/current/upcoming progress state, which doesn't fit this purely
// explanatory "how it works" list where no step represents real order progress.
interface XrStepProps {
  number?: number | string
  title?: string
  description?: string
  isLast?: boolean
}

defineProps<XrStepProps>()
</script>
